import * as React from 'react';

import { ItemsProvider, SortingDirection } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';

import { Special } from '@app/objects/Special';
import SpecialCard from '@app/components/Pages/Specials/SpecialCard';
import '@app/scss/pages/special.scss';
import SpecialModal from '@app/components/Pages/Specials/SpecialModal';

interface Props {
	items: any;
}

export const SpecialsInner: React.FC<Props> = ({ items }) => {
	const [item, setItem] = React.useState<Special>();

	return <>
		<SpecialModal item={item} onClose={() => setItem(undefined)} />
		<div className="container specials-container">
			<div className="special-list__wrapper">
				<div className="special-list">
					{' '}
					{items && items.list.map((special: Special) => {
						return <SpecialCard openModal={setItem} item={special} key={special.id} />;
					})}
				</div>
			</div>
		</div>
	</>;
};

const Specials: React.FC = () => {
	return <>
		<ServerPageProvider
			path="specials"
			defaultTitle="Specials"
			inner={(page) => (
				<ItemsProvider<Special>
					type="special"
					items={page?.items?.list}
					loadRequest="specialsList"
					filters={{
						column: [
							{ caption: 'name', direction: SortingDirection.Ascending },
							{ caption: 'price', direction: SortingDirection.Default }],
					}}
					pagination={{ total: page?.items?.count }}
					withHandleUrl
				>
					<SpecialsInner items={page.items} />
					<style>
						{'.app-container {background: #eeeff3;}'}
					</style>
				</ItemsProvider>
			)}
		/>
	</>;
};

export default Specials;
